<template>
    <b-card no-body>
        <UpdateEmailTemplatesModal :update_email_templates.sync="modals.update_email_templates" v-on:closeEmailModal="closeEmailModal()" :template_data="template_data" />
        <UpdateNotifTemplatesModal :update_notif_templates.sync="modals.update_notif_templates" v-on:closeNotifModal="closeNotifModal()" :template_data="template_data" />
        <EmailNotificationTemplatesModal :email_notification_templates.sync="modals.email_notification_templates" v-on:closeEmailNotificationModal="closeEmailNotificationModal()" :template_data="template_data" />
        <BellNotificationTemplatesModal :bell_notification_templates.sync="modals.bell_notification_templates" v-on:closeBellNotificationModal="closeBellNotificationModal()" :template_data="template_data" />

        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
            </b-row>
        </b-col>

         <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="queriedData"
                style="width: 100%;"
            >
            <el-table-column
                prop="notif_temp_type"
                label="Type"
                sortable
                >
                <template slot-scope="scope">
                  <p class="text-capitalize" >{{ scope.row.notif_temp_type }}</p>
                </template>
                </el-table-column>

              
    
                <el-table-column
                prop="notif_temp_title"
                label="Title"
                sortable
                >
                <template slot-scope="scope">
                    <p class="text-capitalize" >{{ scope.row.notif_temp_title }}</p>
                </template>
                </el-table-column>

                <el-table-column
                prop="notif_temp_message"
                label="Content"
                sortable
                min-width="200"
                >
                <template slot-scope="scope">
                    <p class="font-weight-bold text-primary">{{ scope.row.notif_temp_message }}</p>
                </template>
                </el-table-column>

                <!-- Trigger Point Column -->
                <el-table-column prop="trigger_point" label="Trigger Point" sortable>
                    <template slot-scope="scope">
                        <p class="text-capitalize">{{ getTriggerPointText(scope.row.trigger_point,scope.row.notif_temp_type) }}</p>
                    </template>
                </el-table-column>

                <!-- STATUS CREATED AT COLUMN -->
                <el-table-column
                    prop="created_at"
                    label="Date Created"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                    
                </el-table-column>

                <!-- STATUS ACTIONS COLUMN -->
                <el-table-column
                    width="55"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown :tabindex="scope.row.id" class="py-2">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="editTemplate(scope.row,scope.row.notif_temp_type)">
                                    Edit
                                </el-dropdown-item>
                                <el-dropdown-item 
                                    v-if="scope.row.notif_temp_type === 'email' && 
                                          (scope.row.trigger_point === 'ASSIGN_ADVISOR')"
                                    @click.native="notificationTemplate(scope.row, scope.row.notif_temp_type)">
                                    Notification
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="deleteTemplate(scope.row.notif_temp_id)">
                                    Delete
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
    </b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import mainEventBus from '@/assets/js/mainEventBus.js'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import UpdateEmailTemplatesModal from '@/views/Configurations/EmailAndNotifTemplates/TemplatesModals/UpdateEmailTemplatesModal'
import UpdateNotifTemplatesModal from '@/views/Configurations/EmailAndNotifTemplates/TemplatesModals/UpdateNotifTemplatesModal'
import EmailNotificationTemplatesModal from '@/views/Configurations/EmailAndNotifTemplates/TemplatesModals/EmailNotificationTemplatesModal'
import BellNotificationTemplatesModal from '@/views/Configurations/EmailAndNotifTemplates/TemplatesModals/BellNotificationTemplatesModal'
import { useNotificationStore } from '@/stores/notificationStore'
import { mapState, mapActions } from 'pinia'
import { EMAIL_TRIGGER_POINTS , NOTIFICATION_TRIGGER_POINTS } from "@/assets/js/status.js";
import { useAccessControlStore } from "@/stores/accessControlStore";

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        UpdateEmailTemplatesModal,
        UpdateNotifTemplatesModal,
        EmailNotificationTemplatesModal,
        BellNotificationTemplatesModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            modals: {
                update_email_templates: false,
                update_notif_templates: false,
                email_notification_templates: false,
                bell_notification_templates: false,
            },
            isTableLoading: true,
            // propsToSearch:['sms_title', 'sms_content'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: [],
            queriedData: [], // Initialize this to an empty array
            searchQuery: '', // Ensure this is also initialized
            template_data: {},
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500]
            },
        }
    },
    created(){
        this.getTemplate()
    },  
    mounted() {
        this.debouncedHandler = debounce(() => {
          this.filterTableData();
        }, 500);

        mainEventBus.$on('refresh-status', this.getTemplate)
    },
    beforeUnmount() {
        mainEventBus.$off('refresh-status', this.getTemplate)
    },
     methods: {
		...mapActions(useNotificationStore, ['getTemplates']),
        filterTableData() {
            // Apply filter based on search query
            this.queriedData = this.tableData.filter(item => {
                const typeMatch = item.notif_temp_type ? item.notif_temp_type.toLowerCase().includes(this.searchQuery.toLowerCase()) : false;
                const titleMatch = item.notif_temp_title ? item.notif_temp_title.toLowerCase().includes(this.searchQuery.toLowerCase()) : false;
                const messageMatch = item.notif_temp_message ? item.notif_temp_message.toLowerCase().includes(this.searchQuery.toLowerCase()) : false;
                return typeMatch || titleMatch || messageMatch;
            });

        },
        getTriggerPointText(triggerPoint,type) {
    
          if(type === 'email')
          {
            return EMAIL_TRIGGER_POINTS[triggerPoint] || triggerPoint
          }
          else{
            return NOTIFICATION_TRIGGER_POINTS[triggerPoint] || triggerPoint
          }
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getTemplate(){
					const params = {
						search:{
							notif_temp_type: 'email',
							application_code: _gAuth.appCode(),
							corporate_id: _gAuth.activeCorporateId(),
						}
					}
					this.getTemplates(params).then((resp) => {
						this.tableData = resp;
						this.queriedData = resp;
						this.filterTableData();
						this.isTableLoading = false
					}).catch((err)=>{
						this.isTableLoading = false
					})
        },
        editTemplate(template,type){
          this.template_data = template
          if(type === 'email')
          {
            this.modals.update_email_templates = true;
          }
          else{
            this.modals.update_notif_templates = true;
          }
        },
        notificationTemplate(template,type){
          this.template_data = template
          if(type === 'email')
          {
            this.modals.email_notification_templates = true;
          }
          else{
            this.modals.bell_notification_templates = true;
          }
        },
        deleteTemplate(notif_temp_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.notification + '/notif-template/' + notif_temp_id, {headers: getHeader()})
                    .then(res => {
                            this.getTemplate()
                            this.notifySuccess('<b>Status: </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                }
            })
        },
        closeEmailModal(){
            this.modals.update_email_templates = false
        },
        closeNotifModal(){
            this.modals.update_notif_templates = false
        },
        closeEmailNotificationModal(){
            this.modals.email_notification_templates = false
        },
        closeBellNotificationModal(){
            this.modals.bell_notification_templates = false
        },
    }
}
</script>